<button class="back-btn" (click)="getNextPage()" *ngIf="!hideNextButton">
  <svg class="svg-icon icon-icon" style="transform: rotate(180deg);">
    <use xlink:href="/assets/svg/app-extra-icons.svg#icon-navigate"></use>
  </svg>
</button>
